export const OVERVIEW = {
  title: 'Overview',
  name: 'overview',
  active: true,
  updated: false,
  error: false,
  is_saved: false,
  in_overview: false,
  icon: 'font-size-16 icon-fileText1',
};

export const PRESS_NEWS = {
  title: 'Press & News',
  name: 'press_news',
  active: true,
  updated: false,
  error: false,
  is_saved: true,
  in_overview: false,
  icon: 'font-size-16 icon-shoppingList',
};

export const FINANCIAL_INFORMATION = {
  title: 'Financial Information',
  name: 'financial_information',
  active: true,
  updated: false,
  error: false,
  is_saved: false,
  in_overview: false,
  icon: 'font-size-16 icon-folder',
};

export const STOCK_INFORMATION = {
  title: 'Stock Information',
  name: 'stock_information',
  active: true,
  updated: false,
  error: false,
  is_saved: true,
  in_overview: false,
  icon: 'font-size-16 icon-stackedArea--up',
};

export const ABOUT_US = {
  title: 'About Us',
  name: 'about_us',
  active: false,
  updated: false,
  error: false,
  is_saved: false,
  in_overview: false,
  icon: 'font-size-16 icon-fileUser',
};

export const GOVERNANCE = {
  title: 'Governance',
  name: 'governance',
  active: false,
  updated: false,
  error: false,
  is_saved: false,
  in_overview: false,
  icon: 'font-size-16 icon-bank',
};

export const SHAREHOLDER_SERVICES = {
  title: 'Shareholder Services',
  name: 'shareholder_services',
  active: false,
  updated: false,
  error: false,
  is_saved: false,
  in_overview: false,
  icon: 'font-size-16 icon-boxes',
};

export const LATEST_PRESENTATION = {
  title: 'Latest Presentation',
  name: 'latest_presentation',
  active: false,
  updated: false,
  error: false,
  is_saved: false,
  in_overview: false,
  icon: 'font-size-16 icon-airPlay',
};

export const OPTIONS_LIST = [
  OVERVIEW,
  PRESS_NEWS,
  FINANCIAL_INFORMATION,
  STOCK_INFORMATION,
  ABOUT_US,
  GOVERNANCE,
  SHAREHOLDER_SERVICES,
  LATEST_PRESENTATION,
];
